if (!window.customElements.get('product-sticky-corner-button-motti')) {
  class ProductStickyCornerButtonMotti extends HTMLElement {
    constructor() {
      super();
      this.intersectionObserver = new IntersectionObserver((entries) => this.handleFormVisibilityChange(entries));
      this.formElement = null;
    }

    connectedCallback() {
      this.formElement = document.forms[this.getAttribute('form')];

      if (this.formElement) {
        this.intersectionObserver.observe(this.formElement);
      }
    }

    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }

    handleFormVisibilityChange(entries) {
      const formEntry = entries.find((entry) => entry.target === this.formElement);

      if (!formEntry) return;

      const isBelowViewport = !formEntry.isIntersecting && formEntry.boundingClientRect.top > 0;

      this.classList.toggle('is-visible', isBelowViewport);
    }
  }

  window.customElements.define('product-sticky-corner-button-motti', ProductStickyCornerButtonMotti);
}
